module.exports = __webpack_public_path__ + "static/media/about.e8ac8a69.png";